<template>

  <DataTable :value="cart" stripedRows
    responsiveLayout="stack"
    breakpoint="960px"
    :autoLayout="true" class="after-sales-table-full p-mt-4 cart-table"
    sortField="code" :sortOrder="1"
    >
    
    <Column field="code" :header="$t('spareParts.cart.col_code')" ></Column>
    <Column field="description" :header="$t('spareParts.cart.col_description')" ></Column>
    <Column field="comment" :header="$t('spareParts.cart.col_comment')" >
      <template #body="slotProps">
        <img src="assets/irinox/icons/cart_add_notes.svg" :alt="$t('spareParts.cart.col_comment')" v-tooltip="slotProps.data.comment" @click="openEditComment(slotProps.data)"/>
      </template>
    </Column>
    <Column field="quantity" :header="$t('spareParts.cart.col_quantity')" >
      <template #body="slotProps">
        <div class="p-d-flex p-ai-center" style="gap: 10px;">
            <Button icon="pi pi-minus"  @click="() => { updateItem(slotProps.data, -1) }" />
            <div class="big p-text-center" style="width: 30px;">{{ slotProps.data.quantity }}</div>
            <Button icon="pi pi-plus" @click="() => { updateItem(slotProps.data, +1) }"/>
        </div>
      </template>
    </Column>
    <Column :header="$t('spareParts.cart.col_total')" >
      <template #body="slotProps">
        <span v-if="slotProps.data.price && slotProps.data.currency">
          {{ $n((slotProps.data.price * slotProps.data.quantity), 'money') }}
          {{ slotProps.data.currency === 'EUR' ? '€ ' : '$ ' }}
        </span>
        <span v-else>
          <i>{{ $t('spareParts.on_demand') }}</i>
        </span>
      </template>
    </Column>

    <Column field="docTreeId">
      <template #body="slotProps">
        <div class="p-d-flex p-ai-center after-sales-datatable-buttons p-jc-end">
          <i class="icon-trash" @click="removeItem(slotProps.data.code)"></i>
        </div>
      </template>
    </Column>

  </DataTable>

  <Dialog v-model:visible="dialog.editComment" class="irinox-dialog-light" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              >
    
      <template #header>
        <img src="assets/irinox/icons/arrow_back.svg" @click="dialog.editComment = false" :alt="$t('common.arrow_left')"/>
        <div>{{$t('spareParts.cart.editComment_title')}}</div>
      </template>

      <div class="irinox-dialog-light-content layout-content">
        <div class="irinox-form p-pt-2">
          <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-col-12 p-d-flex p-flex-column p-jc-center">
                <label for="notes" class="gray p-text-bold">{{ $t('spareParts.notes') }}</label>
                <Textarea id="notes" v-model="edit.comment" rows="3" :placeholder="$t('spareParts.notes_ph')" />
              </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button :label="$t('spareParts.cart.editComment_button')" style="width: fit-content" @click="updateItem(edit, 0)"/>
      </template>

  </Dialog>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('spareParts.cart.error_dialog')" :life="3000"
    @update:visible="dialog.error = $event" />

</template>

<script>
import { mapGetters } from 'vuex';
import AfterSalesService from '../../../service/AfterSalesService';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';

export default {
  components: {
    IrinoxDialogDark
  },
  data() {
    return {
      dialog: {
        editComment: false,
        error: false,
      },
      edit: {
        code: null,
        comment: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      role: 'userdata/role',
      cart: 'afterSales/cart'
    }),
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
  },
  methods: {
    removeItem(code) {
      this.afterSalesService.deleteSpCart(this.personaltoken, code, true, false)
        .then((data) => {
          if (data.code === "200") {
            this.$store.commit('afterSales/cart', data.body);
          } else {
            this.$store.commit('afterSales/cart', []);
            console.error(JSON.stringify(data));
          }
        })
        .catch(error => {
          this.$store.commit('afterSales/cart', []);
          console.error("ERROR " + error);
        });
    },
    updateItem(item, qty) {
      console.log("updateItem", item, qty);
      if(qty<0) {
        this.afterSalesService.deleteSpCart(this.personaltoken, item.code, false, false)
          .then((data) => {
            if (data.code === "200") {
              this.$store.commit('afterSales/cart', data.body);
            } else {
              this.$store.commit('afterSales/cart', []);
              console.error(JSON.stringify(data));
            }
          })
          .catch(error => {
            this.$store.commit('afterSales/cart', []);
            console.error("ERROR " + error);
          })
          .finally(() => {
            this.dialog.editComment = false;
          });
      } else {
        this.afterSalesService.putSpCart(this.personaltoken, item.code, qty, item.comment)
          .then((data) => {
            if (data.code === "200") {
              this.$store.commit('afterSales/cart', data.body);
            } else {
              this.$store.commit('afterSales/cart', []);
              console.error(JSON.stringify(data));
            }
          })
          .catch(error => {
            this.$store.commit('afterSales/cart', []);
            console.error("ERROR " + error);
          })
          .finally(() => {
            this.dialog.editComment = false;
          });
      }
    },
    openEditComment(item) {
      this.edit.code = item.code;
      this.edit.comment = item.comment;
      this.dialog.editComment = true;
    }
  }
}
</script>

<style scoped>
</style>